import $ from 'jquery'
import _ from 'lodash'

// -------------- Flash alerts --------------

// prettier-ignore
export const constructFlashMessage = (type, message) => {
    return `
        <div class="alert alert-dismissible fade show" style="display: none" role="alert">
            <div class="alert-${type}" role="alert">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close"></button>
                <strong>${message}</strong>
            </div>
        </div>
    `;
}

export const FLASH_MESSAGE_TYPE = {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'danger',
    SUCCESS: 'success',
}

export const FLASH_MESSAGE_FADE_SPEED = 1000 // ms

export const addFlashMessage = (type, message, $placing = $('div.alert-container')) => {
    const alert = constructFlashMessage(type, message)
    $placing.append(alert)
    $placing.find('.alert').fadeIn(FLASH_MESSAGE_FADE_SPEED)
}

export const addFlashMessageSuccess = (message, $placing = $('div.alert-container')) => {
    const alert = constructFlashMessage(FLASH_MESSAGE_TYPE.SUCCESS, message)
    $placing.append(alert)
    $placing.find('.alert').fadeIn(FLASH_MESSAGE_FADE_SPEED)
}

export const addFlashMessageInfo = (message, $placing = $('div.alert-container')) => {
    const alert = constructFlashMessage(FLASH_MESSAGE_TYPE.INFO, message)
    $placing.append(alert)
    $placing.find('.alert').fadeIn(FLASH_MESSAGE_FADE_SPEED)
}

export const addFlashMessageWarning = (message, $placing = $('div.alert-container')) => {
    const alert = constructFlashMessage(FLASH_MESSAGE_TYPE.WARNING, message)
    $placing.append(alert)
    $placing.find('.alert').fadeIn(FLASH_MESSAGE_FADE_SPEED)
}

export const addFlashMessageError = (message, $placing = $('div.alert-container')) => {
    const alert = constructFlashMessage(FLASH_MESSAGE_TYPE.ERROR, message)
    $placing.append(alert)
    $placing.find('.alert').fadeIn(FLASH_MESSAGE_FADE_SPEED)
}

export const redirectAfterDelay = (url, delay) => {
    setTimeout(() => {
        window.location.href = url
    }, delay)
}

export const initLabelTriggerCustomCheckbox = () => {
    const $label = $('.custom-checkbox .inpt__lbl')
    if (!$elementExists($label)) return

    $label.on('click', 'a', function (e) {
        e.stopPropagation()
    })

    $label.on('click', function () {
        const $nearestInput = $(this).parents('.custom-checkbox').find('input[type=checkbox]')
        $nearestInput.prop('checked', function (_, val) {
            return !val
        })
    })
}

// ----- Address -----

const ALLOWED_ADDRESS_CHARS = /[^a-zA-Z0-9 \-'./,]/g
const ALLOWED_HOUSE_NAME_CHARS = /[^a-zA-Z0-9 \-'./,&]/g

export const filterAddressField = ($input) => {
    $input.on('input', function () {
        const cur = $(this).val()
        const filtered = cur.replace(ALLOWED_ADDRESS_CHARS, '')
        if (filtered !== cur) $(this).val(filtered)
    })
}

export const filterHouseNameField = ($input) => {
    $input.on('input', function () {
        const cur = $(this).val()
        const filtered = cur.replace(ALLOWED_HOUSE_NAME_CHARS, '')
        if (filtered !== cur) $(this).val(filtered)
    })
}

// -------------- Helper functions --------------

export class Scenes {
    defaultScene = null
    activeScenes = new Set()

    constructor(sceneMap) {
        this.sceneMap = sceneMap
    }

    hide(sceneName) {
        $(this.sceneMap[sceneName].join(',')).hide()
        this.activeScenes.delete(sceneName)
        return this
    }

    hideAll() {
        if (!this.activeScenes.size) return this
        this.activeScenes.forEach((scene) => this.hide(scene))
        return this
    }

    switchTo(sceneName) {
        this.hideAll()
        this.show(sceneName)
        this.activeScenes.add(sceneName)
        return this
    }

    show(sceneName) {
        $(this.sceneMap[sceneName].join(',')).show()
        this.activeScenes.add(sceneName)
        return this
    }

    showDefault() {
        if (!this.defaultScene) console.error('Missing default')
        this.hideAll()
        this.show(this.defaultScene)
        return this
    }

    setDefault(sceneName) {
        this.defaultScene = sceneName
        this.activeScenes.add(this.defaultScene)
        this.show(sceneName)
        return this
    }

    getCurrent() {
        return [...this.activeScenes]
    }
}

// -------------- Form helpers --------------

export const elementInnitVal = (element) => $elementInnitVal($(element))

export const $elementInnitVal = ($element) => $element.prop('defaultValue')

export const elementExists = (element) => $elementExists($(element))

export const $elementExists = ($element) => $element.length > 0

export const elementIsVisible = (element) => $elementIsVisible($(element))

export const $elementIsVisible = ($element) => $element.is(':visible') && !$element.is(':hidden')

export const elementHasVal = (element) => $elementHasVal($(element))

export const $elementHasVal = ($element) => _.reduce([$selectIsSelected($element), $radioIsChecked($element), $checkboxIsChecked($element), $rangeIsFilled($element), $inputIsFilled($element), $textAreaIsFilled($element)], (accum, result) => accum || result, false)

// ----- <Textarea> -----
export const elementIsTextArea = (element) => $(element).is('textarea')

export const $elementIsTextArea = ($element) => $element.is('textarea')

export const $textAreaIsFilled = ($element) => $elementIsTextArea($element) && _.trim($element.val()) !== ''

// ----- <Select> -----
export const elementIsSelect = (element) => $elementIsSelect($(element))

export const $elementIsSelect = ($element) => $element.is('select')

export const $selectIsSelected = ($element) => $elementIsSelect($element) && !!$element.find(':selected').val()

// ----- <Radio> -----
export const elementIsRadio = (element) => $elementIsRadio($(element))

export const $elementIsRadio = ($element) => $element.is(':radio')

export const $radioIsChecked = ($element) => $elementIsRadio($element) && $element.filter(':checked').val()

// ----- <Checkbox> -----
export const elementIsCheckbox = (element) => $elementIsCheckbox($(element))

export const $elementIsCheckbox = ($element) => $element.is(':checkbox')

export const $checkboxIsChecked = ($element) => $elementIsCheckbox($element) && $element.filter(':checked').val()

// ----- <Date> -----
export const elementIsDate = (element) => $(element).attr('type') === 'date'

// ----- <Range> -----
export const elementIsRange = (element) => $elementIsRange($(element))

export const $elementIsRange = ($element) => $element.attr('type') === 'range'

export const $rangeIsFilled = ($element) => $elementIsRange($element) && true // TODO make $element.val() >= min && $element.val() <= max

// ----- <Input> -----
export const elementIsInput = (element) => $elementIsInput($(element))

export const $elementIsInput = ($element) => ['text', 'tel', 'number', 'email', 'password', 'hidden', 'date'].includes($element.attr('type')) // Be aware of 'hidden' !!!

export const $inputIsFilled = ($element) => $elementIsInput($element) && _.trim($element.val()) !== ''

// ----- <Password> -----
export const elementIsPassword = (element) => $elementIsPassword($(element))

export const $elementIsPassword = ($element) => $element.attr('type') === 'password'

// ----- Helpers -----
export const $disableElement = ($element) => $element.attr('disabled', true)

export const $readonlyElement = ($element) => $element.attr('readonly', true)

export const $enableElement = ($element) => $element.attr('disabled', false) && $element.attr('readonly', false)

export const $clearElement = ($element) => $element.val('')

export const $elementHashVal = ($element) => [$selectIsSelected($element), $radioIsChecked($element), $checkboxIsChecked($element), $element.val()].join()

export const $hideElement = ($element) => $element.hide()

export const $showElement = ($element) => $element.show()

export const $restoreElement = ($element) => $element.val($elementInnitVal($element))

export const $elementIsType = ($element) => ($element.is('input') ? $element.attr('type') : $element.prop('tagName').toLowerCase())
